<template>
  <div class="houseList" id="houseList">
    <div class="top">
      <div class="searchBox">
        <div style="width: 100%">
          <a-form-model
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            :layout="formLayout"
            labelAlign="left"
            ref="ruleForm"
            v-if="downShow">
            <a-row class="paddingL20">
              <a-col :span="4">
                <div class="flex" style="color: #000; height: 40px">
                  <div style="width: 80px; display: flex;">品牌名称：</div>
                  <div class="flex">
                    <div v-if="userInfo&&userInfo.brandName ? true :false" class="bold">{{ userInfo.brandName }}</div>
                    <div v-else class="bold">-</div>
                  </div>
                </div>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="区域">
                  <a-select
                    mode="multiple"
                    show-search
                    option-filter-prop="children"
                    @change="regionChange"
                    v-model="form.districtIdList"
                    class="w150"
                  >
                    <a-select-option v-for="item in districtList" :key="item.areaId" :value="item.areaId">{{
                      item.areaName
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="商圈">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    v-model="form.businessDistrictIdList"
                    @change="businessDistrictMethod"
                    mode="multiple"
                    class="w150"
                  >
                    <a-select-option v-for="item in businessDistrictList" :key="item.id" :value="item.id">{{
                      item.businessDistrictName
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="街道">
                  <a-select
                    show-search
                    option-filter-prop="children"
                    v-model="form.streetIdList"
                    class="w150"
                    mode="multiple"
                  >
                    <a-select-option v-for="item in streetList" :key="item.id" :value="item.id">{{
                      item.streetFullName
                    }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="楼层">
                  <!-- mode="multiple" -->
                  <a-select
                    :show-arrow="true"
                    v-model="form.houseFloorTypeList"
                    class="w75"
                    :label-col="{ span: 3 }"
                    :wrapper-col="{ span: 21 }"
                    @change="houseFloorChange"
                  >
                    <a-select-option v-for="item in floorTypeOpts" :key="item.dictLabel" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                  <a-input
                    v-if="form.houseFloorTypeList === '1'"
                    class="w75"
                    type="text"
                    v-model="form.houseFloor"
                    placeholder="楼层数"
                    :maxLength="7"
                    @input="intValidate('houseFloor')"
                  />
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- @change="timeSwitching" -->
            <!-- <a-input
                    class="w75"
                    type="text"
                    v-model="form.startHouseFloor"
                    placeholder="开始"
                    :maxLength="7"
                    @input="intValidate('rentExpenseStart')"
                  />-
                  <a-input
                    class="w75"
                    type="text"
                    v-model="form.endHouseFloor"
                    placeholder="结束"
                    :maxLength="7"
                    @input="intValidate('rentExpenseEnd')"
                  /> -->

            <a-row class="paddingL20">
              <a-col :span="9">
                <a-form-model-item
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                  label="租金"
                  prop="rentExpenseStart"
                >
                  <a-input
                    class="w75"
                    type="text"
                    @change="timeSwitching"
                    v-model="time.rentExpenseStart"
                    placeholder="开始"
                    :maxLength="7"
                    @input="intValidate('rentExpenseStart')"
                  />-
                  <a-input
                    class="w75"
                    type="text"
                    @change="timeSwitching"
                    v-model="time.rentExpenseEnd"
                    placeholder="结束"
                    :maxLength="7"
                    @input="intValidate('rentExpenseEnd')"
                  /><span style="width: 40px; height: auto; display: inline-block">
                    <!-- {{ flag === 1 ? '元/月' : flag === 0 ? '元/日' : '' }} -->
                  </span>
                  <a-select placeholder="月租金" v-model="flag" style="width: 90px">
                    <a-select-option :value="2">不限</a-select-option>
                    <a-select-option :value="0">月租单价</a-select-option>
                    <a-select-option :value="1">月租金</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="15">
                <a-form-model-item label="行业搜索" :label-col="{ span: 3}" :wrapper-col="{ span: 20 }">
                  <div style="display: flex">
                    <a-select
                      show-search
                      option-filter-prop="children"
                      mode="multiple"
                      v-model="form.industryCategoryJsonId"
                      @change="getSubIndustryList"
                      class="w240 mr10"
                    >
                      <a-select-option :value="item.id" v-for="item in canIndustryList" :key="item.id">{{
                        item.industryCategoryName
                      }}</a-select-option>
                    </a-select>
                    <a-select
                      show-search
                      option-filter-prop="children"
                      mode="multiple"
                      v-model="form.industrySubclassJsonId"
                      class="w240 mr10"
                    >
                      <a-select-option :value="item.id" v-for="item in canSubIndustryList" :key="item.id">
                        {{ item.industryCategoryName }}
                      </a-select-option>
                    </a-select>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="9">
                <!-- <div style="display: flex"> -->
                <!-- <div style="width:120px;padding-top:10px">是否可有转让费：</div> -->
                <a-form-model-item label="是否可有转让费">
                  <a-select v-model="form.isHaveTransferFee" placeholder="请选择" class="w150">
                    <a-select-option v-for="item in weatherOpts" :key="item.dictValue" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <!-- </div> -->
              </a-col>
              <a-col :span="5">
                <a-form-model-item label="商铺类型" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                  <!-- mode="multiple" -->
                  <a-select
                    :show-arrow="true"
                    v-model="form.shopType"
                    class="w150"
                    :label-col="{ span: 3 }"
                    :wrapper-col="{ span: 21 }"
                  >
                    <a-select-option v-for="item in shopTypeOpts" :key="item.dictLabel" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col class="" :span="5">
                <a-form-model-item style="display: flex" label="面积" :label-col="{ span: 6,offset:0 }" :wrapper-col="{ span: 24 }">
                  <div style="display: flex">
                    <a-input
                      class="w75"
                      placeholder="起始"
                      v-model="form.startAcreage"
                      suffix="m²"
                      :maxLength="5"
                    />
                    &nbsp;-&nbsp;
                    <a-input
                      class="w75"
                      placeholder="结束"
                      v-model="form.endAcreage"
                      suffix="m²"
                      :maxLength="5"
                    />
                  </div>
                </a-form-model-item>
              </a-col>
              <a-col class="" :span="5">
                <a-form-model-item style="display: flex" label="层高" :label-col="{ span: 6,offset:0 }" :wrapper-col="{ span: 24 }">
                  <div style="display: flex">
                    <a-input
                      class="w75"
                      placeholder="起始"
                      v-model="form.houseHighStart"
                      suffix="m²"
                      :maxLength="5"
                    />
                    &nbsp;-&nbsp;
                    <a-input
                      class="w75"
                      placeholder="结束"
                      v-model="form.houseHighEnd"
                      suffix="m²"
                      :maxLength="5"
                    />
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="15">
                <div class="list_ancillary_arr">
                  <!-- <div style="width:120px;padding-top:10px">商铺配套：</div> -->
                  <a-form-model-item label="商铺配套" class="ancillary_arr" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                    <ul >
                      <li>
                        <a-checkbox-group class="list_checkbox_group" v-model="form.shopAncillaryIdList" @change="shopAncillaryChange">
                          <a-checkbox v-for="item in shopAncillaryOpts" :key="item.dictValue" :value="item.dictValue">
                            {{ item.dictLabel }}
                          </a-checkbox>
                        </a-checkbox-group>
                      </li>
                    </ul>
                  </a-form-model-item>
                </div>
              </a-col>
              <a-col :span="3">
                 <a-button type="primary" @click="resetValue">
                  重置
                </a-button>
              </a-col>
            </a-row>
            <div style="text-align: right; padding-right: 143px"></div>
          </a-form-model>
        </div>
      </div>
    </div>
    <div class="midhr"></div>
    <div class="topcenter" v-show="loading">
      <LoadingModel></LoadingModel>
    </div>
    <a-divider />
    <div class="btn-box">
      <button class="btn" @click="onekeyPush()">一键推铺</button>
    </div>
    <div class="shoplist-title" v-show="records.length">
      <div></div>
      <div></div>
      <div v-for="(v, i) in shopListTitle" :key="v">
        <div class="title-item" @click="handleSort(i)">
          <span :class="{ cur: curLook[i] }">{{ v }} </span>
          <div class="icon">
            <a-icon type="caret-up" :class="{ cur: curLook[i] && form.sortType == 'ASC' }" />
            <a-icon type="caret-down" :class="{ cur: curLook[i] && form.sortType == 'DESC' }" />
          </div>
        </div>
      </div>
    </div>
    <a-divider v-show="records.length" />
    <a-spin :spinning="loading">
      <houseList v-if="pageName === 'rentDetail'" :records="records"></houseList>
      <houseSellList v-if="pageName === 'sellDetail'" :records="records"></houseSellList>
    </a-spin>
    <div v-show="isShow">
      <a-pagination
        v-if="records.length"
        :current="form.pageNum"
        :page-size="form.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        :total="shopPagination.total"
        @change="onChange"
        class="dateli"
      />
      <div v-else>
        <no-data></no-data>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingModel from '@/components/Loading'
import houseList from '@/components/houseList/houseList.vue'
import houseSellList from '@/components/houseList/houseSellList.vue'
import houseApi from '@/api/system/houses/house.js'
import sellTouristApi from '@/api/system/tourist/sell_tourist.js'
import { industryClassSelMixin } from '@/mixin/industrySelect'

import { locationSelectMixin } from '@/mixin/locationSelect'

export default {
  name: 'RentHouseList',
  components: {
    houseList,
    houseSellList,
    LoadingModel
  },
  props: {
    pageName: {
      type: String,
      default: 'rentDetail',
      require: true
    },
    userInfo: {
      type: Object,
      require: false,
      default: () => {
        return {}
      }
    }
  },
  mixins: [locationSelectMixin, industryClassSelMixin],
  data () {
    return {
      curLook: [false, false, false, false],
      // 店铺推荐
      loading: false,
      shopListTitle: ['元/月', '元/m²/月', '面积', '盘别'],
      isShow: false,
      records: [],
      repastTypeOpts: [], // 允许的餐饮类型
      weatherOpts: [], // 是否
      form: {
        isHaveTransferFee: undefined,
        alloweCateringTypeId: undefined, //	允许的餐饮类型ID 字典表类型：repast_type		false
        hourseSort: 1, // 房源排序（1：默认 2：租金(元/月) 3：租金(元/平方米/月) 4：带看 5：面积 6：盘别）
        houseResourceType: 1,
        pageNum: 1,
        pageSize: 10,
        sortType: 'ASC', // 排序规则 ASC / DESC
        businessDistrictId: '', // 商圈id
        startRentFee: '', // 价格
        endRentFee: '',
        houseFloorType: '', // 楼层类型
        startHouseFloor: '', // 楼层
        endHouseFloor: '',
        search: '',
        startAcreage: '', // 面积开发
        endAcreage: '', // 面积结束
        houseStatus: '1', // 房源状态 字典表类型：house_status
        // 多选
        houseFloorTypeList: [], // 楼层类型 字典表类型：floor_type
        houseFloor: undefined,
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],
        industryCategoryId: undefined, // 行业分类ID	query	false	string
        industrySubclassId: undefined, // 经营行业ID	query	false	string
        industryCategoryJsonId: [], // 行业大类ID（可经营）(多选，以“，”隔开)
        industrySubclassJsonId: [], // 行业小类ID（可经营）	(多选，以“，”隔开)

        houseHighStart: undefined, // 层高开始
        houseHighEnd: undefined, // 层高结束
        shopType: undefined, // 需求商铺类型
        shopAncillaryIdList: [] // 商铺配套
      },
      rules: {
       endAcreage: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'change'
          },
          { validator: this.requirementAreaEndRule, trigger: 'blur' } // 结束的需求面积验证
        ],
        startAcreage: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { validator: this.requirementAreaEndRule, trigger: 'blur' } // 开始的需求面积验证
        ],
        houseHighEnd: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'change'
          },
          { validator: this.houseHighEndRule, trigger: 'blur' } // 结束的层高验证
        ],
        houseHighStart: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { validator: this.houseHighEndRule, trigger: 'blur' } // 开始的层高验证
        ]
      },
      shopPagination: {
        total: 0
      },
      time: {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      },
      flag: 1,

      activeNum: 1,
      rentUnit: '', // 租金单位
      form_startRentFee: undefined, // 租金开始（显示的）
      form_endRentFee: undefined, // 租金结束（显示的）
      rentStartDate: undefined, // 日租金开始
      rentEndDate: undefined, // 日租金结束
      rentStartMonth: undefined, // 月租金开始
      rentEndMonth: undefined, // 月租金结束
      // 信息
      AllList: [],
      // 日期控制禁用
      rqflag: true,
      // 租金切换
      zujinfalg: true,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      formLayout: 'horizontal',
      // 查询表单
      searchForm: {
        rqselect: 'all',
        rqstart: '',
        rqend: ''
      },
      pagination: {
        current: 1,
        total: 1,
        size: 3,
        pageSizeOptions: ['10', '20', '30']
      },
      sort: 1,
      direction: 'down',
      direction2: 'down',
      direction3: 'down',
      direction4: 'down',
      direction5: 'down',
      direction6: 'down',

      // 维护人 部门
      newForm: {
        deptId: ''
      },
      // 查询框更多按钮事件
      downShow: true,
      // 房源状态(有效,已租,我租,不租,错误)
      houseStatusData: [],
      // 区域列表
      districtData: [],
      // 商圈列表
      businessDistrict: [],
      // 商铺类型
      shopType: [],
      // 街道列表
      StreetData: [],
      // 带看日期范围
      dateTypeOpts: [
        { id: 1, name: '今日' },
        { id: 2, name: '昨日' },
        { id: 3, name: '本周' },
        { id: 4, name: '上周' },
        { id: 5, name: '本月' },
        { id: 6, name: '上月' },
        { id: 7, name: '全部' }
      ],

      // 楼层数
      floorData: [],
      // 楼层类型
      floorTypeOpts: [],
      // 商铺类型 字典表类型：shop_type
      shopTypeOpts: [],
      // 餐饮类型
      repastType: [],
      // 人员部门
      PersonGav: [],
      a: null,
      // 维护人所属部门id
      PersonId: '',
      // 部门列表
      deptListData: [],
      // 部门对应人员
      depPerson: [],
      userList: [],
      // 商铺配套
      shopAncillaryOpts: []
    }
  },
  created () {
    // 获取房源信息列表
    this.getDicts('repast_type').then((response) => {
      this.repastTypeOpts = response.data
      this.repastTypeOpts.forEach((item) => {
        if (item.dictLabel === '拒餐饮') {
          // a删除拒餐饮
          this.repastTypeOpts.splice(item.dictSort - 1, 1)
        }
      })
    })
    // this.dataList()
    this.getDicts('sys_yes_no').then((response) => {
      this.weatherOpts = response.data
    })
    // 房源状态
    this.getDicts('house_status').then((res) => {
      if (res.code === 200) {
        this.houseStatusData = res.data
      }
    })
    // 商铺配套
    this.getDicts('shop_ancillary').then((response) => {
       this.shopAncillaryOpts = response.data ? response.data.filter((item) => {
        return '天然气，烟道，动力电，外摆区，写字楼，景区，学校，商场，医院，住宅'.indexOf(item.dictLabel) > -1
       }) : []
    })
    // 商铺类型
    this.getDicts('shop_type').then((res) => {
      if (res.code === 200) {
        this.shopType = res.data
      }
    })
    // 楼层数
    this.getDicts('floor_num').then((res) => {
      if (res.code === 200) {
        this.floorData = res.data
      }
    })
    // 楼层类型
    this.getDicts('floor_type').then((res) => {
      if (res.code === 200) {
        this.floorTypeOpts = res.data
      }
    })
    // 商铺类型 字典表类型：shop_type
    this.getDicts('shop_type').then((res) => {
      if (res.code === 200) {
        this.shopTypeOpts = res.data
      }
    })
    // 维护人所属部门id
    this.getDicts('related_personne_type').then((res) => {
      if (res.code === 200) {
        this.PersonGav = res.data
        this.a = this.PersonGav.find((item) => {
          return item.dictLabel === '维护人'
        })
        this.PersonId = this.a.dictSort
      }
    })

    // 餐饮类型
    this.getDicts('repast_type').then((res) => {
      if (res.code === 200) {
        this.repastType = res.data
      }
    })
  },

  methods: {
    resetValue(){
      Object.keys(this.form).forEach(el=>{
        if(Array.isArray(this.form[el])){
          this.form[el] = []
        }else{
          this.form[el] = null
        }
        
      })
      Object.keys(this.time).forEach(el=>{
        this.time[el] = null
      })
    },
    // 需求面积自定义验证操作
    requirementAreaEndRule (rule, value, callback) {
      if (parseFloat(this.form.requirementAreaStart) > parseFloat(value)) {
        callback(new Error('面积填写请从小到大'))
      } else {
        callback()
      }
    },
    // 层高自定义验证操作
    houseHighEndRule (rule, value, callback) {
      if (parseFloat(this.form.houseHighStart) > parseFloat(value)) {
        callback(new Error('层高填写请从小到大'))
      } else {
        callback()
      }
    },
    shopAncillaryChange (val) {
      // this.form.shopAncillaryIdList = val
    },
    getState () {
      this.form.alloweCateringTypeId = undefined
    },
    onChange (current, pageSize) {
      this.form.pageNum = current
      this.form.pageSize = pageSize
      this.getHouseList()
    },
    // 一键推铺
    onekeyPush () {
      const MINACREAGE = this.form.startAcreage
      const MAXACREAGE = this.form.endAcreage
      const MINHIGH = this.form.houseHighStart
      const MAXHIGH = this.form.houseHighEnd
      const REG = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      if ((MINACREAGE || MAXACREAGE) && (!REG.test(MINACREAGE) || !REG.test(MAXACREAGE))) {
        this.$message.error('面积值格式错误或未填写完整')
      } else if ((MINHIGH || MAXHIGH) && (!REG.test(MINHIGH) || !REG.test(MAXHIGH))) {
        this.$message.error('层高值格式错误或未填写完整')
      } else if ((MINACREAGE || MAXACREAGE) && parseFloat(MINACREAGE) > parseFloat(MAXACREAGE)) {
        this.$message.error('面积起始值不可超过结束值')
      } else if ((MINHIGH || MAXHIGH) && parseFloat(MINHIGH) > parseFloat(MAXHIGH)) {
        this.$message.error('层高起始值不可超过结束值')
      } else {
        this.getHouseList()
        this.isShow = true
      }
    },
    // 房源信息查询列表
    getHouseList () {
      this.loading = true
      const params = { ...this.form }
      // params.search = this.userInfo?.brandName || ''
      if (params.startRentFee === '0.00') params.startRentFee = ''
      if (params.endRentFee === '0.00') params.endRentFee = ''
      if (params.startAcreage === '0.00') params.startAcreage = ''
      if (params.endAcreage === '0.00') params.endAcreage = ''
      if (this.pageName === 'rentDetail') {
        houseApi.houseInfoList(params).then((res) => {
          if (res.code === 200) {
            this.records = res.data.records
            this.shopPagination.total = res.data.total
            this.loading = false
          } else {
            this.$message.warning('房源信息获取失败')
            this.loading = false
          }
        })
      } else {
        sellTouristApi.gethouseInfoList(this.form).then((res) => {
          if (res.code === 200) {
            this.records = res.data.records
            this.shopPagination.total = res.data.total
            this.loading = false
          } else {
            this.$message.warning('房源信息获取失败')
            this.loading = false
          }
        })
      }
    },
    // 租金范围
    timeSwitching () {
      if (this.flag === 1) {
        this.form.startRentFee = this.time.rentExpenseStart
        this.form.endRentFee = this.time.rentExpenseEnd
      } else if (this.flag === 0) {
        this.form.startRentFee = this.time.rentExpenseStart * 30
        this.form.endRentFee = this.time.rentExpenseEnd * 30
      } else {
        this.form.startRentFee = ''
        this.form.endRentFee = ''
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
      }
    },
    // int验证
    intValidate (fieldName) {
      const val =
        fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd' ? this.time[fieldName] : this.form[fieldName]
      const reg = /^[0-9]{1,6}$/
      if (!reg.test(val)) {
        if (fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd') {
          this.time[fieldName] = ''
        } else {
          this.form[fieldName] = ''
        }
      }
    },
    // 筛选排序
    handleSort (index) {
      if (index === 0) {
        this.form.hourseSort = 2
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else if (index === 1) {
        this.form.hourseSort = 3
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else if (index === 2) {
        this.form.hourseSort = 5
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      } else {
        this.form.hourseSort = 6
        this.curLook = [false, false, false, false]
        this.curLook[index] = true
        this.form.sortType = this.form.sortType === 'ASC' ? 'DESC' : 'ASC'
        this.getHouseList()
      }
    },
    // 租金切换方法
    zujin (val) {
      if (val === 1) {
        this.zujinfalg = true // 为日租金
      } else {
        this.zujinfalg = false // 为月租金
      }
    },
    houseFloorChange (e) {
      if (e !== '1') {
        this.form.houseFloor = undefined
      }
    }
  },
  watch: {
    flag () {
      if (this.flag === 1) {
        this.time.rentExpenseStart = this.form.startRentFee
        this.time.rentExpenseEnd = this.form.endRentFee
      } else if (this.flag === 0) {
        this.time.rentExpenseStart = this.form.startRentFee
          ? (this.form.startRentFee / 30).toFixed(2)
          : this.time.rentExpenseStart
        this.time.rentExpenseEnd = this.form.endRentFee
          ? (this.form.endRentFee / 30).toFixed(2)
          : this.time.rentExpenseEnd
      } else {
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
        this.form.startRentFee = ''
        this.form.endRentFee = ''
      }
    }
  }
}
</script>
<style>
.menu .ant-tabs-bar {
  width: 100%;
}
</style>
<style lang="less" scoped>
.paddingL20 {
  padding-left: 20px;
}
.mr10 {
  margin-right: 10px;
}
.w75 {
  width: 75px;
}
.w120 {
  width: 120px;
}
.w150 {
  width: 150px;
}
.w180 {
  width: 180px;
}
//店铺推荐
.btn-box {
  width: 100%;
  height: 100px;
  position: relative;
  .btn {
    width: 260px;
    height: 50px;
    font-weight: 700;
    letter-spacing: 1px;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 26px;
    background-color: var(--ThemeColor);
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
.shoplist-title {
  display: flex;
  font-weight: 700;
  & > :nth-child(1) {
    height: 32px;
    width: 33.333%;
  }
  & > :nth-child(2) {
    width: 16.6%;
  }
  & > :nth-child(3) {
    width: 16.6%;
    position: relative;
    & > .title-item {
      width: 60px;
      position: absolute;
      left: -115%;
      top: 0;
    }
  }
  & > :nth-child(4) {
    width: 16.6%;
    position: relative;
    & > .title-item {
      width: 80px;
      position: absolute;
      left: -170%;
      top: 0;
    }
  }
  & > :nth-child(5) {
    width: 8%;
    position: relative;
    & > .title-item {
      width: 60px;
      position: absolute;
      left: -365%;
      top: 0;
    }
  }
  & > :nth-child(6) {
    width: 8%;
    position: relative;
    & > .title-item {
      width: 60px;
      position: absolute;
      left: 10%;
      top: 0;
    }
  }

  .title-item {
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      display: flex;
      margin-left: 2px;
      flex-direction: column;
    }
    .cur {
      color: var(--ThemeColor);
    }
  }
}
.flex {
  align-items: center;
  display: flex;
}
.dateli {
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: right;
  margin-right: 30px;
}
.list_ancillary_arr{
  display:flex;
  .ancillary_arr{
    width:100%;
    ul{
      margin-left: 0;
      padding-left: 0px;
      li{
        list-style: none;
        margin-bottom: 20px;
        margin-top: 10px;
        .list_checkbox_group{
          display: flex;
          flex-wrap: wrap;
        }
      }
    }
  }
}
</style>
